export const DASHBOARD_DATEPICKER = [
  {
    id: "date",
    label: "",
    placeHolder: "Select",
    type: "daterangebothvalue",
    md: 2.5,
    // disablePast: true,
  },
];

export const DASHBOARD_FILTER_SOURCE = [
  // {
  //   id: "isArchieved",
  //   label: "",
  //   placeHolder: "Select",
  //   type: "radio",
  //   row: true,
  //   md: 4.5,
  //   radioOptions: [
  //     {
  //       label: "Exluded Archived",
  //       value: "All",
  //     },
  //     {
  //       label: "Included Archived",
  //       value: "Archived",
  //     },
  //   ],
  // },
  {
    id: "source",
    label: "",
    placeHolder: "Select",
    type: "select",
    options: ["LEAD", "BOOKING", "FINANCE"],
    //   { value: "LEAD", label: "Lead Conversion Rate" },
    //   { value: "BOOKING", label: "Booking Trends" },
    //   { value: "FINANCE", label: "Finance Performance" },
    // ],
    md: 4.5,
  },
];

export const CHART_BAR = [
  {
    period: "1 week",
    total_count: "10",
    status_count: "5",
  },
  {
    period: "2 week",
    total_count: "20",
    status_count: "10",
  },
  {
    period: "3 week",
    total_count: "30",
    status_count: "15",
  },
  {
    period: "4 week",
    total_count: "40",
    status_count: "20",
  },
  {
    period: "5 week",
    total_count: "50",
    status_count: "25",
  },
];

export const CHART_PIE = [
  {
    status: "NEW LEAD",
    data: {
      count: 10,
      percent: "20%",
    },
  },
  {
    status: "ESTIMATE",
    data: {
      count: 15,
      percent: "30%",
    },
  },
  {
    status: "SURVEY",
    data: {
      count: 5,
      percent: "10%",
    },
  },
  {
    status: "QUOTE",
    data: {
      count: 20,
      percent: "40%",
    },
  },
];
